import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { ConfiguracionCompensacion, ConfiguracionCompensacionPK } from 'src/app/models/configuracionCompensacion.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { InscripcionPlanCompensacion } from 'src/app/models/inscripcionPlanCompensacion.model';

@Component({
    selector: 'app-aprobacion-inscripcion-compensacion',
    templateUrl: './aprobacion-inscripcion-compensacion.component.html'
})
export class AprobacionInscripcionCompensacionComponent implements OnInit, OnChanges {

    @Input() inscripcionSeleccionada: InscripcionPlanCompensacion;
    @Input() numeroDocumento: string;
    @Output() response = new EventEmitter();

    modalOptionsAprobarInscripcionCompensacion: any;
    modalOptionsDevolverInscripcionCompensacion: any;
    modalOptionsRechazarInscripcionCompensacion: any;

    estadosInscripcion: DetalleDominio[];
    estadoInscripcion: string;

    plan: PlanCompensatorioModel;
    inscripcion: ConfiguracionCompensacion;

    codigoTurnoAnterior: number;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.modalOptionsAprobarInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_APROBACION_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Aprobar',
            null, 'btn-secondary');
        this.modalOptionsDevolverInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_DEVOLUCION_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Devolver',
            null, 'btn-secondary');
        this.modalOptionsRechazarInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_RECHAZO_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Rechazar',
            null, 'btn-secondary');
        this.obtenerDominio('EstadoInscripcionPlanCompensacion', 'estadosInscripcion');
    }

    ngOnChanges() {
        if (this.inscripcionSeleccionada !== undefined) {
            this.inscripcion = new ConfiguracionCompensacion();
            this.inscripcion.configuracionCompensacionPK = new ConfiguracionCompensacionPK();
            this.inscripcion.configuracionCompensacionPK.tipoIdFuncionario = this.inscripcionSeleccionada.tipoIdFuncionario;
            this.inscripcion.configuracionCompensacionPK.numeroIdFuncionario = this.inscripcionSeleccionada.numeroIdFuncionario;
            this.inscripcion.estado = DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE;
            this.inscripcion.horasAjuste = 0;
            this.inscripcion.porcentajeCompensacion = 0;
            this.estadoInscripcion = this.inscripcionSeleccionada.estado;
            this.consultarPlanCompensacionActual();
        }
    }

    public habilitarBotones() {
        const fechaActual: Date = new Date();
        this.modalOptionsAprobarInscripcionCompensacion.disabled =
            !((this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE)
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaInicialAutorizacion))).getTime() <=
            this.utilService.setearFinFecha(fechaActual).getTime()
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalAutorizacion))).getTime() >=
            this.utilService.setearFinFecha(fechaActual).getTime());
        this.modalOptionsDevolverInscripcionCompensacion.disabled =
            !((this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE)
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaInicialAutorizacion))).getTime() <=
            this.utilService.setearFinFecha(fechaActual).getTime()
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalAutorizacion))).getTime() >=
            this.utilService.setearFinFecha(fechaActual).getTime());
        this.modalOptionsRechazarInscripcionCompensacion.disabled =
            !((this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE)
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaInicialAutorizacion))).getTime() <=
            this.utilService.setearFinFecha(fechaActual).getTime()
            && (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalAutorizacion))).getTime() >=
            this.utilService.setearFinFecha(fechaActual).getTime());
    }

    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     * @function obtenerDominio
     * @author dfranco@asesoftware.com
     * @param filtro Dominio a consultar
     * @param lista Variable a la que se va a asignar el resultado
     */
    obtenerDominio(filtro, lista) {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    /**
     * Método que permite consultar el plan de compensación activo o actual
     * @function consultarPlanCompensacionActual
     * @author dfranco@asesoftware.com
     */
    public consultarPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=estado', DominiosService.ESTADO_PLAN_COMPENSACION_ACTIVO]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan = data[0];
                this.consultarTurnosPlanCompensacionActual();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar los turnos parametrizados en el plan de compensación actual
     * @author dfranco@asesoftware.com
     * @function consultarTurnosPlanCompensacionActual
     */
    public consultarTurnosPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarTurnosCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=idPlanCompensacion', this.plan.idPlanCompensacion.toString()]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan.listaTurnos = data;
                this.consultarInscripcionFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar turnos asociados al plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la inscripción del formulario al plan de compensación actual
     * @function consultarInscripcionFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarInscripcionFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarInscripcionPlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.inscripcionSeleccionada.tipoIdFuncionario]);
        queryParams.push(['numeroDocumento', this.inscripcionSeleccionada.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data !== undefined) {
                    this.inscripcion = data;
                    this.codigoTurnoAnterior = this.inscripcion.configuracionCompensacionPK.turnoIdTurno;
                }
                if (this.estadosInscripcion !== undefined) {
                    const estadosFiltrados = this.estadosInscripcion.filter(
                        estado => estado.detalleDominioPK.nombreDetalleDominio === this.inscripcion.estado);
                    if (estadosFiltrados.length > 0) {
                        this.estadoInscripcion = estadosFiltrados[0].valor;
                    }
                }
                this.habilitarBotones();
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que aprueba una inscripción a plan de compensación
     * @function aprobarInscripcion
     * @author dfranco@asesoftware.com
     * @param  event Elemento que contiene decisión del usuario para realizar acción
     * @param  estado Código del estado que será asignado de acuerdo a la decisión del usuario 
     */
    public gestionarInscripcion(event: any[], estado: string) {
        if (event[0]) {
            const fechaActual: Date = new Date();
            this.inscripcion.estado = estado;
            let continuar = true;
            if ((this.utilService.setearFinFecha(new Date(this.plan.fechaInicialAutorizacion))).getTime() <=
                this.utilService.setearFinFecha(fechaActual).getTime() &&
                (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalAutorizacion))).getTime() >=
                this.utilService.setearFinFecha(fechaActual).getTime()) {
                if (this.inscripcion.estado !== DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO) {
                    continuar = this.utilService.validarCamposObligatorios(this.inscripcion.observacionesJefeArea);
                    if (!continuar) {
                        this.alertService.generateAlertError(ConstantesService.MENSAJE_OBSERVACION_OBLIGATORIA_INSCRIPCION, '');
                    }
                }
                if (continuar) {
                    this.spinner.show();
                    const serviceProvider = 'editarEstadoInscripcionPlan';
                    const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
                        this.urlService.hostAPI_FUNCIONARIOS);
                    this.global.postGenerico(url, this.inscripcion).subscribe(
                        data => {
                            this.consultarInscripcionFuncionario();
                            switch (this.inscripcion.estado) {
                                case DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO:
                                    this.alertService.generateAlertSuccess(ConstantesService.MENSAJE_EXITO_APROBACION_INSCRIPCION, '');
                                    break;
                                case DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_DEVUELTO:
                                    this.alertService.generateAlertSuccess(ConstantesService.MENSAJE_EXITO_DEVOLUCION_INSCRIPCION, '');
                                    break;
                                case DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_RECHAZADO:
                                    this.alertService.generateAlertSuccess(ConstantesService.MENSAJE_EXITO_RECHAZO_INSCRIPCION, '');
                                    break;
                                default:
                                    break;
                            }
                        }, err => {
                            if (err.status === '500') {
                                this.catchException(err.error.message);
                            } else {
                                this.catchException(ConstantesService.MENSAJE_ERROR_ACTUALIZACION_ESTADO_INSCRIPCION);
                            }
                        }
                    );
                }
            } else {
                this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTEN_SOLICITUDES_APROBAR, '');
            }
        }
    }

    /**
     * Método que permite regresar al listado de planes de compensación
     * @author dfranco@asesoftware.com
     * @function volver
     */
    volver() {
        this.response.emit();
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }






}